var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReports(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 2C3.16421 2 3.5 2.33579 3.5 2.75V18.4531H19.2031C19.6172 18.4533 19.9531 18.789 19.9531 19.2031C19.953 19.6171 19.6171 19.953 19.2031 19.9531H2.75C2.33589 19.9531 2.00017 19.6172 2 19.2031V2.75C2 2.33579 2.33579 2 2.75 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97656 13.4079L9.06915 8.76527C9.07384 8.75954 9.08286 8.76048 9.08627 8.76705L11.6183 13.3571C11.6318 13.3816 11.6657 13.385 11.6838 13.3636L17.316 6.70732M17.316 6.70732L14.2538 6.70735M17.316 6.70732V9.79991",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.ada37a9a.svg";
export { ForwardRef as ReactComponent };